import { useHasIntegratedSolution, useSelectedPlan } from '@store';
import { PlanDetail } from '@types';
import { useMemo } from 'react';
import { useLogger } from '@hooks';

interface MonthlyAmountInput {
	plan?: PlanDetail;
}

interface MonthlyAmountOutput {
	hasIntegratedSolution: boolean;
	amounts: Amounts;
}

interface Amounts {
	softwareAmount: number;
	bankAmount: number;
	finalMonthlyAmount: number;
}

export const useAmounts = (props: MonthlyAmountInput): MonthlyAmountOutput => {
	const logger = useLogger();
	const { plan: planProps } = props;
	const hasIntegratedSolution = useHasIntegratedSolution();
	const planSelected = useSelectedPlan();
	const plan = planProps === undefined ? planSelected : planProps;

	logger('useAmounts', {
		planProps,
		planSelected,
		hasIntegratedSolution,
	});

	const amounts = useMemo((): Amounts => {
		const returnedAmounts: Amounts = {
			bankAmount: planSelected?.serviceBank as number,
			softwareAmount: planSelected?.serviceSoftware as number,
			finalMonthlyAmount: plan?.monthlyAmount as number,
		};
		// if (hasIntegratedSolution) {
		// 	const amountWithIntegratedSolution = (plan?.monthlyAmount as number) / 2;
		// 	returnedAmounts = {
		// 		finalMonthlyAmount: amountWithIntegratedSolution,
		// 		bankAmount: amountWithIntegratedSolution / 2,
		// 		softwareAmount: amountWithIntegratedSolution / 2,
		// 	};
		// }
		return returnedAmounts;
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasIntegratedSolution, planSelected]);

	return { amounts, hasIntegratedSolution };
};
